import { render, staticRenderFns } from "./unilevel.vue?vue&type=template&id=56647f1f"
import script from "./unilevel.vue?vue&type=script&lang=js"
export * from "./unilevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports